// extracted by mini-css-extract-plugin
module.exports = {"campaign-reminder":"styles___campaign-reminder___1zqVq","calendar-icon":"styles___calendar-icon___1jjWo"};